import { Type } from '@sinclair/typebox';
export var PermissionType;
(function (PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["COMMENT"] = "COMMENT";
    PermissionType["VIEW"] = "VIEW";
    PermissionType["DISABLED"] = "DISABLED";
})(PermissionType || (PermissionType = {}));
export var ReviewPermissionType;
(function (ReviewPermissionType) {
    ReviewPermissionType["ALLOWED"] = "ALLOWED";
    ReviewPermissionType["PROHIBITED"] = "PROHIBITED";
})(ReviewPermissionType || (ReviewPermissionType = {}));
// enum values should match properties in PermissionModel
export var PermissionResource;
(function (PermissionResource) {
    PermissionResource["OVERVIEW"] = "overview";
    PermissionResource["BUDGET"] = "budget";
    PermissionResource["FORECAST"] = "forecast";
    PermissionResource["ATA"] = "ata";
    PermissionResource["INVOICE"] = "invoice";
    PermissionResource["FILES"] = "files";
    PermissionResource["REVIEW"] = "review";
})(PermissionResource || (PermissionResource = {}));
export var PermissionRouteName;
(function (PermissionRouteName) {
    PermissionRouteName["STARTPAGE"] = "STARTPAGE";
    PermissionRouteName["PROJECTS"] = "PROJECTS";
    PermissionRouteName["OVERVIEW"] = "OVERVIEW";
    PermissionRouteName["BUDGET"] = "BUDGET";
    PermissionRouteName["FORECAST"] = "FORECAST";
    PermissionRouteName["ATA"] = "ATA";
    PermissionRouteName["INVOICE"] = "INVOICE";
    PermissionRouteName["FILES"] = "FILES";
    PermissionRouteName["ADMIN"] = "ADMIN";
    PermissionRouteName["INVALID"] = "INVALID";
})(PermissionRouteName || (PermissionRouteName = {}));
export const PermissionModel = Type.Object({
    id: Type.Optional(Type.String()),
    projectId: Type.String(),
    userId: Type.String(),
    overview: Type.Enum(PermissionType),
    budget: Type.Enum(PermissionType),
    forecast: Type.Enum(PermissionType),
    ata: Type.Enum(PermissionType),
    invoice: Type.Enum(PermissionType),
    // D12: the SharePoint file-access tier. COMMENT deliberately maps to the same effective access as
    // VIEW in SharePoint (D13) — it keeps its own site group so the six tiers stay a 1:1 mirror of
    // this enum.
    files: Type.Enum(PermissionType),
    review: Type.Enum(ReviewPermissionType),
});
// Request bodies only. `files` is optional here so a client built before the FILES tier existed can
// still create and update permissions — omitting it means "no opinion on the file tier": the server
// falls back to the column default (DISABLED) on create and leaves the stored tier untouched on
// update. Responses always carry the field, so `PermissionModel` keeps it required and readers never
// have to handle `undefined`.
export const WritePermissionModel = Type.Composite([
    Type.Omit(PermissionModel, ['files']),
    Type.Object({
        files: Type.Optional(Type.Enum(PermissionType)),
    }),
]);
export const ListPermissionsModel = Type.Array(PermissionModel);
export const ListUserPermissionsParamModel = Type.Object({
    userId: Type.String(),
});
export const ListProjectPermissionsParamModel = Type.Object({
    projectId: Type.String(),
});
export const ListUserProjectPermissionsParamModel = Type.Object({
    userId: Type.String(),
    projectId: Type.String(),
});
export const DeletePermissionsParamModel = Type.Object({
    id: Type.String(),
});
